import { PageScroll } from "@Components/Page";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { styled } from "@mui/material/styles";
import { WorkflowTypes } from "@Types/workflow";
import { DocumentIcon, FormatIcon, GroupedList, ListRow, LockIcon, PageTitle, SectionLabel, StructureIcon, TimelineCreateIcon, TimelineIcon } from "@UI";
import { createConfig } from "@Utils/createConfig";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const ICONS = {
    TimelineCreate: TimelineCreateIcon,
    TimelineImport: TimelineIcon,
    StructureImport: StructureIcon,
    TemplateLibrary: DocumentIcon,
    StyleConverter: FormatIcon
};
const Locked = styled(LockIcon)({
    color: "var(--j-ink-3)"
});
const SECTIONS = [
    {
        label: "workflows.sections.fromDocument",
        items: [
            WorkflowTypes.TimelineCreate
        ]
    },
    {
        label: "workflows.sections.fromJuristic",
        items: [
            WorkflowTypes.TimelineImport,
            WorkflowTypes.StructureImport
        ]
    },
    {
        label: "workflows.sections.format",
        items: [
            WorkflowTypes.TemplateLibrary,
            WorkflowTypes.StyleConverter
        ]
    }
];
export function WorkflowOverview({ onOpenWorkflow }) {
    const { t } = useTranslation();
    const token = useUserContext((s)=>s?.user?.meta?.access_token.token);
    const user = useUserContext((s)=>s?.user);
    const [hasStyleDocument, setHasStyleDocument] = useState(false);
    useEffect(()=>{
        const fetchStyleDocument = async ()=>{
            try {
                const header = createConfig(token);
                const url = `${gatewayUrl}/plugins/word/styleDocuments`;
                const { data } = await axios.get(url, header);
                setHasStyleDocument(!!data);
            } catch (error) {
                console.error("Failed to fetch style document:", error);
            }
        };
        fetchStyleDocument();
    }, [
        token
    ]);
    const hasCviToolAccess = (user?.meta?.dbUser?.accesses || []).includes("wordPluginCviTool");
    return /*#__PURE__*/ React.createElement(PageScroll, null, /*#__PURE__*/ React.createElement(PageTitle, {
        title: t("workflows.multiple"),
        lede: t("workflows.description")
    }), SECTIONS.map((section)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: section.label
        }, /*#__PURE__*/ React.createElement(SectionLabel, null, t(section.label)), /*#__PURE__*/ React.createElement(GroupedList, null, section.items.filter((type)=>type !== WorkflowTypes.StyleConverter || hasCviToolAccess).map((type)=>{
            const Icon = ICONS[type];
            const isDisabled = type === WorkflowTypes.StyleConverter && !hasStyleDocument;
            return /*#__PURE__*/ React.createElement(ListRow, {
                key: type,
                icon: /*#__PURE__*/ React.createElement(Icon, null),
                iconTone: isDisabled ? "neutral" : "primary",
                title: t(`workflows.${type}.title`),
                description: t(isDisabled ? "workflows.StyleConverter.disabledTooltip" : `workflows.${type}.description`),
                disabled: isDisabled,
                chevron: !isDisabled,
                trailing: isDisabled && /*#__PURE__*/ React.createElement(Locked, {
                    size: 14
                }),
                onClick: ()=>onOpenWorkflow(type)
            });
        })))));
}
